import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from './ui/card';
import { Button } from './ui/Button';
import { Input } from './ui/input';
import { Checkbox } from './ui/checkbox';
import { Upload } from 'lucide-react';
import Logo from '../Images/onest.png';
import RealEstate from '../Images/R&E.png';
import { saveAgentInfo, saveTasks } from '../api/onboardingService';

const OnboardingApp = () => {
  const [currentPage, setCurrentPage] = useState('input');
  const [formData, setFormData] = useState({
    name: '',
    mlsNumber: '',
    nrdsNumber: '',
    licenseNumber: '',
    headshot: null,
    shortBio: '',
    longBio: '',
  });

  const [tasks, setTasks] = useState({
    skyslope: false,
    regusOffice: false,
    email: false,
    oneDrive: false,
    officeNumber: false,
    teams: false,
    homestack: false,
    nvar: false,
    narLogin: false,
    vaRealtor: false,
    brightMls: false,
    remine: false,
    rpr: false,
    showingTime: false,
    sentrilock: false,
    homes: false,
    hihello: false,
    googleBusiness: false,
    facebook: false,
    instagram: false,
    realtorCom: false,
    zillow: false,
    kvAgent: false,
    kvCore: false,
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      headshot: file,
    });
  };

  const handleSubmit = () => {
    const formDataPayload = {
      name: formData.name,
      mlsNumber: formData.mlsNumber,
      nrdsNumber: formData.nrdsNumber,
      licenseNumber: formData.licenseNumber,
      headshot: formData.headshot ? formData.headshot.name : '',
      shortBio: formData.shortBio,
      longBio: formData.longBio,
    };

    saveAgentInfo(formDataPayload)
      .then((response) => {
        console.log(response.data);
        if (response.data.agent_id) {
          const agentId = response.data.agent_id;
          setCurrentPage('tasks');
          saveTasks(agentId, tasks)
            .then((response) => console.log(response.data))
            .catch((error) => console.error('Error saving tasks:', error));
        }
      })
      .catch((error) => {
        console.error('Error saving agent information:', error);
      });
  };

  const toggleTask = (taskName) => {
    setTasks({
      ...tasks,
      [taskName]: !tasks[taskName],
    });
  };

  // Calculate completion percentage
  const completedTasks = Object.values(tasks).filter(Boolean).length;
  const totalTasks = Object.keys(tasks).length;
  const completionPercentage = (completedTasks / totalTasks) * 100;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with logos */}
      <div className="w-full bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <img src={RealEstate} alt="Main Logo" className="h-10" />
          <img src={Logo} alt="Small Logo" className="h-8" />
        </div>
      </div>

      {currentPage === 'input' ? (
        <Card className="max-w-2xl mx-auto mt-8 border-t-4 border-[#c9a760]">
          <CardHeader>
            <h2 className="text-2xl font-bold text-[#b68319]">Agent Information</h2>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <label className="block mb-2 font-medium text-gray-700">Name</label>
              <Input
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Full Name"
                className="border-2 focus:border-[#c9a760] focus:ring-[#c9a760]"
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">MLS Number</label>
              <Input
                name="mlsNumber"
                value={formData.mlsNumber}
                onChange={handleInputChange}
                placeholder="MLS #"
                className="border-2 focus:border-[#c9a760] focus:ring-[#c9a760]"
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">NRDS Number</label>
              <Input
                name="nrdsNumber"
                value={formData.nrdsNumber}
                onChange={handleInputChange}
                placeholder="NRDS #"
                className="border-2 focus:border-[#c9a760] focus:ring-[#c9a760]"
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">License Number</label>
              <Input
                name="licenseNumber"
                value={formData.licenseNumber}
                onChange={handleInputChange}
                placeholder="License #"
                className="border-2 focus:border-[#c9a760] focus:ring-[#c9a760]"
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">Short Bio</label>
              <Input
                name="shortBio"
                value={formData.shortBio}
                onChange={handleInputChange}
                placeholder="Short Bio"
                className="border-2 focus:border-[#c9a760] focus:ring-[#c9a760]"
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">Long Bio</label>
              <textarea
                name="longBio"
                value={formData.longBio}
                onChange={handleInputChange}
                placeholder="Long Bio"
                className="w-full border-2 focus:border-[#c9a760] focus:ring-[#c9a760] p-2 rounded-md"
              />
            </div>
            <div>
              <label className="block mb-2 font-medium text-gray-700">Headshot</label>
              <div className="flex items-center space-x-2">
                <Input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="hidden"
                  id="headshot"
                />
                <Button
                  onClick={() => document.getElementById('headshot').click()}
                  className="w-full bg-[#c9a760] hover:bg-[#b68319] text-white"
                >
                  <Upload className="w-4 h-4 mr-2" />
                  Upload Headshot
                </Button>
              </div>
            </div>
            <Button
              onClick={handleSubmit}
              className="w-full mt-4 bg-[#b68319] hover:bg-[#c9a760] text-white"
            >
              Submit and Continue to Onboarding Tasks
            </Button>
          </CardContent>
        </Card>
      ) : (
        <Card className="max-w-4xl mx-auto mt-8 border-t-4 border-[#c9a760]">
          <CardHeader>
            <h2 className="text-2xl font-bold text-[#b68319]">Onboarding Tasks</h2>
            {/* Progress bar */}
            <div className="mt-4">
              <div className="flex justify-between text-sm font-medium mb-1">
                <span>Progress</span>
                <span>{Math.round(completionPercentage)}%</span>
              </div>
              <div className="h-2 bg-gray-200 rounded-full">
                <div
                  className="h-2 bg-[#c9a760] rounded-full transition-all duration-500"
                  style={{ width: `${completionPercentage}%` }}
                />
              </div>
            </div>
          </CardHeader>
          <CardContent>
            {/* Basic Setup Section */}
            <section className="bg-white rounded-lg shadow-sm p-6">
              <h3 className="text-xl font-semibold mb-4 text-[#b68319]">Basic Setup</h3>
              <div className="space-y-3">
                {Object.keys(tasks).map((task) => (
                  <div key={task} className="flex items-center space-x-3">
                    <Checkbox
                      checked={tasks[task]}
                      onCheckedChange={() => toggleTask(task)}
                      className="border-[#c9a760] data-[state=checked]:bg-[#c9a760]"
                    />
                    <span className="font-medium">{task}</span>
                  </div>
                ))}
              </div>
            </section>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default OnboardingApp;
